var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2014_2382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 1.3806L11.7856 12.5445C11.7856 12.5445 11.4761 13.3186 10.6243 12.947L5.4916 9.01853C6.18148 8.39837 11.5335 3.58669 11.7675 3.36849C12.1293 3.03079 11.9048 2.82982 11.4843 3.08521L3.5789 8.10552L0.528983 7.07876C0.528983 7.07876 0.0488268 6.90841 0.00261587 6.53681C-0.0438685 6.16521 0.544569 5.96396 0.544569 5.96396L12.978 1.08638C12.978 1.08638 13.9999 0.637395 13.9999 1.3806Z",
    fill: "#23B7EC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2014_2382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegramIcon.ca2e02db728bf75c093667582e9842ba.svg";
export { ForwardRef as ReactComponent };